<template>
    <div>
       <progress-bar ref="progressbar" style="z-index: 3; position: fixed;" :progress="progress"/>
        <topbar style="z-index: 2; position: fixed;" @fadeIn="fadeIn" @fadeOut="fadeOut"/>
        <slideshow ref="slideshow" style="z-index: -4; position: fixed;" @nextslide="label=$event.label" @progress="progress=$event"/>

        <div class="scanLines"></div>
        <div class="overlay" ref="overlay"></div>
        <div class="noise" ref="noise"></div>

        <div ref="label" class="label">{{label}}</div>
        <div ref="triangle" style="position: absolute; bottom:10px; right:10px" @click="scroll">
            <img srcset="../assets/triangle.png 1x,
        ../assets/triangle@2x.png 2x,
        ../assets/triangle@3x.png"
            />
        </div>
        <div class="content">
            <p>we create stunning<br>apps and games.</p>
            <p>
                argumented reality<br>
                location-based<br>
                multiplayer<br>
                sensor-based<br>
                cross-platform
            </p>
            <p>
                <a href="mailto:info@electronauts.net">get in touch></a>
            </p>
            <p>
                <a href="mailto:info@electronauts.net">
                    <img class="logo" srcset="../assets/logo-big.png 1x,
                ../assets/logo-big@2x.png 2x,
                ../assets/logo-big@3x.png 3x"
                    />
                </a>
            </p>

        </div>
        <div class="footer">
           <router-link to="/legalnotice">Legal Notice></router-link>
        </div>
    </div>
</template>

<script>

    import Slideshow from "../components/Slideshow";
    import Topbar from "../components/Topbar";
    import ProgressBar from "../components/ProgressBar";

    export default {
        name: 'home',
        data() {
            return {
                overlayVisible: false,
                label:'',
                progress:0

            }
        },
        components: {ProgressBar, Topbar, Slideshow},
        methods: {
            nextSlide(e, p) {
            },
            scroll(e) {
               window.scroll({ top:window.innerHeight - 5, behavior: 'smooth' });
            },
            fadeIn() {
                this.$refs.overlay.style.display = 'block';
                this.$refs.noise.style.display = 'block';
                TweenLite.to(this.$refs.overlay, 0.5, {opacity: 0.5});
                TweenLite.to(this.$refs.noise, 0.5, {opacity: 0.07});
                TweenLite.to(this.$refs.triangle, 0.2, {opacity: 0});
                TweenLite.to(this.$refs.progressbar, 0.2, {opacity: 0});
                TweenLite.to(this.$refs.label, 0.2, {opacity: 0});
            },
            fadeOut() {
                TweenLite.to(this.$refs.triangle, 0.2, {opacity: 1});
                TweenLite.to(this.$refs.label, 0.2, {opacity: 1});
                TweenLite.to(this.$refs.noise, 0.5, {opacity: 0});
                TweenLite.to(this.$refs.progressbar, 0.5, {opacity: 1});
                TweenLite.to(this.$refs.overlay, 0.53, {
                    opacity: 0, onComplete: () => {
                        this.$refs.overlay.style.display = 'none';
                        this.$refs.noise.style.display = 'none';
                    }
                });
            }
        }
    }
</script>

<style lang="scss">

    @import '../_vars.scss';

    .overlay {
        z-index: -2;
        position: fixed;
        width: 100vw;
        height: 100vh;
        display: none;
        opacity: 0;
        background-color: black;
    }

    .noise {
        z-index: -1;
        position: fixed;
        width: 100vw;
        height: 100vh;
        display: none;
        opacity: 0;
        background-image: url(../assets/noise.gif);
    }

    .footer {
        margin-top: 30px;
        margin-right: 15px;
        margin-bottom: 20px;
        float: right;
        font-size: 10px;
        opacity: 0.5;

    }

    .content {
        padding-top: 100vh;
        z-index: 1;
        overflow-x: hidden;

        color: white;

        font-weight: 900;

        font-size: 9vw;
        line-height: 8.5vw;

        margin-left: 15vw;

        @media screen and (min-width: 1900px) {
            font-size: 180px;
            line-height: 160px;
        }

        @media screen and (max-width: $breakpoint_min) {

        }
    }

    $scanLineWidth: 1.6px;
    .scanLines {
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: -3;
        top: 0;
        left: 0;
        background: -webkit-repeating-linear-gradient(
                        top,
                        transparent 0px,
                        transparent $scanLineWidth,
                        rgba(0, 0, 0, 0.25) $scanLineWidth,
                        rgba(0, 0, 0, 0.25) $scanLineWidth*2
        );
        -webkit-background-size: 100% $scanLineWidth*2;
        background: -moz-repeating-linear-gradient(
                        top,
                        transparent 0px,
                        transparent $scanLineWidth,
                        rgba(0, 0, 0, 0.25) $scanLineWidth,
                        rgba(0, 0, 0, 0.25) $scanLineWidth*2
        );
        -moz-background-size: 100% $scanLineWidth*2;
    }

    .label {
        position: fixed;
        bottom: 10px;
        left: 10px;
        font-weight: 400;
        font-size: 1.5rem;
        @media screen and (max-width: 320px) {
            font-size: 16px;
        }

        @media screen and (max-width: 375px) {
            font-size: 18px;
        }

    }

    .logo {
        @media screen and (max-width: $breakpoint_max) {
            width: 300px;
        }

        @media screen and (max-width: $breakpoint_min) {
            width: 220px;
        }
    }
</style>
